import { Component } from "react";
import PropTypes from "prop-types";
import Grid from "./Grid";

export default class Tasks extends Component {
  constructor(props) {
    super(props);

    this.state = {
      target: null,
      toggleLoader: false,
    };
  }

  toggleTaskLoader = (isLoading) => {
    this.setState({ toggleLoader: isLoading });
  };

  render() {
    const {
      account,
      agent,
      editTask,
      showTaskDetails,
      showDeleteModal,
      showReassignModal,
      showRescheduleModal,
      taskable,
      user,
    } = this.props;

    return (
      <div>
        <Grid
          duenessTitle="Upcoming Task Details"
          agent={agent}
          pagination={{}}
          account={account}
          taskable={taskable}
          dueness={"incomplete"}
          scopes={["incomplete"]}
          showButtons={this.multiSelect}
          selectAllClass={"none"}
          uncomplete={false}
          multiSelectButtons
          polymorphicTasks
          user={user}
          toggleTaskLoader={this.toggleTaskLoader}
          editTask={editTask}
          showReassignModal={showReassignModal}
          showRescheduleModal={showRescheduleModal}
          showDeleteModal={showDeleteModal}
          showTaskDetails={showTaskDetails}
        />
        <Grid
          duenessTitle="Contingent Task Details"
          agent={agent}
          account={account}
          taskable={taskable}
          scopes={["contingent_tasks"]}
          dueness={"contingent"}
          pagination={{}}
          showButtons={this.multiSelect}
          selectAllClass={"little-more-space"}
          createButton={false}
          uncomplete={false}
          multiSelectButtons
          polymorphicTasks
          user={user}
          toggleTaskLoader={this.toggleTaskLoader}
          editTask={editTask}
          showReassignModal={showReassignModal}
          showRescheduleModal={showRescheduleModal}
          showDeleteModal={showDeleteModal}
          showTaskDetails={showTaskDetails}
        />
        <Grid
          duenessTitle="Completed Task Details"
          agent={agent}
          account={account}
          pagination={{}}
          scopes={["complete_tasks"]}
          dueness={"completed"}
          taskable={taskable}
          showButtons={this.multiSelect}
          selectAllClass={"little-more-space"}
          createButton={false}
          uncomplete
          multiSelectButtons={false}
          polymorphicTasks
          user={user}
          toggleTaskLoader={this.toggleTaskLoader}
          editTask={editTask}
          showReassignModal={showReassignModal}
          showRescheduleModal={showRescheduleModal}
          showDeleteModal={showDeleteModal}
          showTaskDetails={showTaskDetails}
        />
      </div>
    );
  }
}

Tasks.propTypes = {
  user: PropTypes.object.isRequired,
};

Tasks.defaultProps = {
  tasks: [],
  user: { name: "No Name" },
  pagination: {},
};
